import { SearchIndexBuilder } from "@viewer/core/search/searchIndexBuilder";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function workerProcessor(data: any) {
  const docs = data;
  const builder = new SearchIndexBuilder();
  return builder.lunrIndex(docs);
}
